<style src="./DashboardParking.scss"  lang="scss"></style>
<template>
  <secton class="DashboardParking">
    <header class="header-container">
      <button class="btn btn-outline" @click="loadParksInfo">
        <i class="fa fa-refresh"></i>
      </button>
    </header>

    <section class="dashcontainer">
      <park-block
        class="park"
        v-for="(park, parkIdx) in parks"
        :key="parkIdx"
        :park="park"
      />
    </section>
  </secton>
</template>

<script>
import ParkBlock from './components/park-block/ParkBlock.vue';
// import draggable from 'vuedraggable';
import { toast } from '@/plugins/toast';

export default {
  name: 'DashboardParking',
  components: {
    ParkBlock,
    // draggable,
  },
  data: () => ({
    parks: [],
  }),
  mounted() {
    // this.parks = fakeParksInfo();
    this.loadParksInfo();
  },
  methods: {
    async loadParksInfo() {
      try {
        const parksInfo = await this.$store.dispatch(
          'PARKING-DASHBOARD/GetParkingDashboardInfo',
        );
        console.log(parksInfo)
        this.parks = parksInfo;
      } catch (error) {
        toast.error('Falha ao carregar informações');
      }
    },
  },
};
</script>
